<template lang="pug">
  b-container(fluid)
    b-row
      b-col(md="12" lg="6")
        b-form-group
          vue-editor(v-model="content")
        .text-center
          b-btn(variant="primary" ,@click="postComment()") Comentar
      b-col(md="12" lg="6")
        h3(v-if="comments") Comentarios
        small(v-else) Aún no hay comentarios
        ul(v-for="comment in comments"
        class="complaint-comments"
        ,:key="comment.id.$oid")
          li.single-complaint-comment
            span.comment-content(v-html="comment.content")
            p.comment-meta(:title="comment.created_at | formatDate")
              small {{ comment.user_name }} - {{ comment.created_at | formatCommentDate }}
</template>

<script>
import kexaApi from '@/services/apiService';
import store from '@/store';
import { VueEditor } from 'vue2-editor';

export default {
  name: 'comments',
  components: {
    VueEditor,
  },
  props: ['complaint'],
  data() {
    return {
      comments: [],
      content: '',
    };
  },
  created() {
    this.fetchComments();
  },
  methods: {
    fetchComments() {
      kexaApi.comments(this.complaint)
        .then((data) => {
          this.comments = data.body;
          store.commit('setCommentsLength', this.comments.length);
        });
    },
    postComment() {
      const $this = this;
      if (this.content !== '<p><br></p>') {
        kexaApi.post_comment(this.complaint, this.content)
          .then(() => {
            $this.content = '';
            $this.fetchComments();
          });
      }
    },
  },
};
</script>

<style lang="scss">
  .complaint-comments {
    padding: 0;
    list-style: none;
  }
  .comment-content {
    display: inline-block;
    background: {
      color: rgba(lightgrey, .3);
    }
    padding: 8px;
    border-radius: 3px;
    p {
      margin: {
        bottom: 0;
      }
    }
    img {
      max-width: 100%;
      height: auto !important;
    }
  }
  .comment-meta {
    opacity: .8;
    font: {
      size: 85%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Comments.vue